
import { Component, Vue } from 'vue-property-decorator';
import { cycleCheckList, addCycleCheck, editCycleCheck, delCycleCheck, getBranchList, syncBranchCycleCheck, getQrCode, getBatchQrCode } from '@/api/cyclCheck';
import { UserModule } from '@/store/modules/user';
import { lAreaData } from '@/const/LAreaData';

import CheckEvent from './components/CheckEvent.vue';
import html2canvas from 'html2canvas';

@Component({
  name: 'CyclCheckEven',
  components: {
    CheckEvent
  }
})
export default class extends Vue {
  private listQuery:any = {
    page: 1,
    size: 10,
    check_name: ''
  };
  private listData = {
    list: [],
    total: 0
  };
  private checkSelected: any = [];

  private loading = false;
  private disabled = false;

  private qrCodeVisible = false;
  private qrCodeStr = '';
  private branchVisible = false;
  private branchListQuery:any = {
    name: '',
    address: [],
    lock: true,
    page: 1,
    size: 10,
    more: '',
    checkSelected: [],
    checkboxSelected: []
  };
  private showButton = {
    branchModule: false
  };
  private branchList:any = [];
  private isIndeterminate = false;
  private checkboxSelectedAll = false;
  private checkboxSelected:any = [];

  private lAreaData:any =[];
  private eventData = {
    id: '',
    check_name: '',
    attribute_arr: [],
    start_time: '',
    end_time: ''
  }
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private customHeight = window.innerHeight * 0.4;
  mounted() {
    // 省市区获取数据
    this.lAreaData = lAreaData;
    this.lAreaData.map((item:any) => {
      if (!item || !item.child || item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item.child.map((temp:any) => {
          if (!temp || !temp.child || temp.child.length === 0) {
            (temp.child as any) = undefined;
          }
        });
      }
    });
  }
  created() {
    this.getCheckList();
    this.checkAuth();
  }
  // 判断是否有分公司模块
  private checkAuth() {
  //
  // this.$http.post("{:url('cycleCheck/checkBranchModule')}").then(
  //   res => {
  //     this.showButton = res.body.showButton;
  //   },
  //   err => {
  //   }
  // );
  }
  // 获取事件列表
  private getCheckList() {
    let _this = this;
    this.loading = true;
    _this.listQuery.user_id = UserModule.getUserId;
    _this.listQuery.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    cycleCheckList(_this.listQuery).then(res => {
      if (res.data != null && res.data.list && res.data.list.length > 0) {
        _this.listData.list = res.data.list;
        _this.listData.total = res.data.count;
      } else {
        _this.listData.list = [];
        _this.listData.total = 0;
      }
      _this.loading = false;
    }).catch(err => {
      let msg = err.msg;
    });
  }

  private dialogEventVisible = false
  private conformAddCheck(val:any) {
    this.doAddCheck(val);
  }
  private closeEventHandle(value: boolean) {
    this.dialogEventVisible = value;
    this.eventData = {
      id: '',
      check_name: '',
      attribute_arr: [],
      start_time: '',
      end_time: ''
    };
  }
  // 编辑事件赋值
  private editCheck(item:any) {
    this.eventData = {
      id: item.id,
      check_name: item.check_name,
      attribute_arr: item.attribute_arr,
      start_time: item.check_start_time,
      end_time: item.check_end_time
    };

    this.dialogEventVisible = true;
  }
  // 添加 编辑事件
  private doAddCheck(eventData:any) {
    let _this = this;
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    parameters.company_name = UserModule.getCompanyName;
    parameters.check_name = eventData.check_name;
    parameters.start_time = eventData.start_time;
    parameters.end_time = eventData.end_time;
    parameters.attribute_arr = eventData.attribute_arr;
    if (eventData.id) {
      parameters.id = eventData.id;
      editCycleCheck(parameters).then(res => {
        _this.dialogEventVisible = false;
        _this.eventData = {
          id: '',
          check_name: '',
          attribute_arr: [],
          start_time: '',
          end_time: ''
        };
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
        this.getCheckList();
      }).catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
    } else {
      addCycleCheck(parameters).then(res => {
        _this.dialogEventVisible = false;
        _this.eventData = {
          id: '',
          check_name: '',
          attribute_arr: [],
          start_time: '',
          end_time: ''
        };
        _this.$notify({
          title: '提示',
          message: (res as any).msg,
          offset: this.customHeight,
          customClass: 'notification-center',
          type: 'success'
        });
        this.getCheckList();
      }).catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
    }
  }
  // 删除事件
  private deleteCheck(id: String) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        let parameters:any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
        parameters.id = id;
        delCycleCheck(parameters).then(res => {
          _this.$notify({
            title: '提示',
            message: (res as any).msg,
            offset: this.customHeight,
            customClass: 'notification-center',
            type: 'success'
          });
          _this.getCheckList();
        }).catch(err => {
          _this.$notify({
            title: '提示',
            message: err.msg,
            offset: 100,
            type: 'error'
          });
        });
      })
      .catch(() => {});
  }
  // 获取二维码
  private getQrCoded(id: String) {
    let _this = this;
    if (this.disabled) {
      return false;
    }
    this.disabled = true;
    let parameters:any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    parameters.id = id;
    getQrCode(parameters).then(res => {
      if (res.data) {
        _this.qrCodeStr = res.data;
        _this.qrCodeVisible = true;
      } else {
        _this.$notify({
          title: '提示',
          message: '操作失败',
          offset: 100,
          type: 'error'
        });
      }
      _this.disabled = false;
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // 导出二维码
  private exportQrCode() {
    if (this.checkSelected.length > 0) {
      let _this = this;
      let idStr = '';
      for (let i = 0; i < this.checkSelected.length; i++) {
        idStr += this.checkSelected[i].id + ',';
      }
      let parameters:any = {};
      parameters.user_id = UserModule.getUserId;
      parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
      parameters.id = idStr;
      getBatchQrCode(parameters).then(res => {
      }).catch(err => {
        if (!err.msg) {
          let blob = new Blob([err]);
          let fileName = new Date().getTime() + '.pdf';
          if ('download' in document.createElement('a')) {
          // 非IE下载
            let elink = document.createElement('a');
            elink.download = fileName;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
          // IE10+下载
            // navigator.msSaveBlob(blob, fileName);
          }
          this.$message.success('下载文件成功');
        } else {
          this.$message.error(err.msg);
        }
      });
      return false;
    } else {
      this.$notify({
        title: '提示',
        message: '请选择事件名称',
        type: 'warning'
      });
    }
  }

  // 下载二维码
  handleDownload() {
    let code = document.querySelector('#cyclCheckEvenQR');
    let filename = new Date().getTime() + '';
    html2canvas(code as any).then(function(canvas:any) {
      let image = new Image();
      image.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
  }

  private handleCheckSelectionAll(val: any) {
    this.checkSelected = val;
  }
  // 搜索
  private search() {
    this.listQuery.page = 1;
    this.listData.list = [];
    this.listData.total = 0;
    this.getCheckList();
  }
  // 重置
  private clear() {
    this.listQuery.page = 1;
    this.listQuery.check_name = '';
    this.listData.list = [];
    this.listData.total = 0;
    this.getCheckList();
  }
  private handleSizeChange(size: number) {
    this.listQuery.size = size; // 每页下拉显示数据
    this.getCheckList();
  }
  private handleCurrentChange(page: number) {
    this.listQuery.page = page; // 点击第几页
    this.getCheckList();
  }

  /**************************************************************/
  // 搜索分公司
  private searchCompanyData() {
    this.branchCompanyList();
  }
  // 重置搜索分公司
  private clearData() {
    this.branchListQuery = {
      name: '',
      address: [],
      lock: true,
      page: 1,
      size: 10,
      more: '',
      checkSelected: [],
      checkboxSelected: []
    };
    this.branchCompanyList();
  }
  // 分公司加载更多
  private moreData() {
    if (this.branchListQuery.lock) {
      this.branchListQuery.page += 1;
      this.branchCompanyList(true);
      this.branchListQuery.lock = false;
    }
  }
  // 获取分公司列表
  private branchCompanyList(flag = false) {
    this.branchListQuery.user_id = UserModule.getUserId;
    this.branchListQuery.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
    getBranchList(this.branchListQuery).then(res => {
      if (res.data) {
        if (flag) {
          if (res.data.list && res.data.list.length) {
            for (var i = 0; i < res.data.list.length; i++) {
              this.branchList.push(res.data.list[i]);
            }
          }
        } else {
          this.branchList = res.data.list;
        }

        // 是否 加载更多
        if (
          this.branchList &&
            this.branchList.length &&
            this.branchList.length < res.data.count
        ) {
          this.branchListQuery.more = 1;
        } else {
          this.branchListQuery.more = '';
        }
      } else {
        this.branchList = [];
        this.branchListQuery.more = '';
      }
      this.branchListQuery.lock = true;
    }).catch(err => {
      let msg = err.msg;
    });
  }

  // 同步数据
  private syncData() {
    let _this = this;
    if (_this.checkboxSelected.length > 0) {
      _this.branchVisible = false;
      let checkId = '';
      for (var checkItem of _this.checkSelected) {
        checkId = checkId + (checkItem as any).id + ',';
      }
      let branchCompanyId = '';
      for (var companyId of _this.checkboxSelected) {
        branchCompanyId = branchCompanyId + companyId + ',';
      }
      let parameters:any = {};
      parameters.user_id = UserModule.getUserId;
      parameters.company_id = UserModule.getCompanyId ? UserModule.getCompanyId : '0';
      parameters.check_id = checkId.substring(0, checkId.length - 1);
      parameters.branch_company_id = branchCompanyId.substring(0, branchCompanyId.length - 1);
      syncBranchCycleCheck(parameters).then(res => {
        if ((res as any).code === 0) {
          _this.$notify({
            title: '分公司数据同步',
            message: '正在同步，结束后可到查看分公司中查看结果。',
            type: 'warning',
            offset: 100,
            duration: 1500
          });
        } else {
          _this.$notify({
            title: '请稍后',
            message: '正在异步同步中，请稍后再点击！',
            type: 'warning',
            offset: 100,
            duration: 1500
          });
        }
      }).catch(err => {
        _this.$notify({
          title: '提示',
          message: err.msg,
          offset: 100,
          type: 'error'
        });
      });
    } else {
      _this.$notify({
        title: '警告',
        message: '请选择分公司',
        type: 'warning',
        offset: 100,
        duration: 1000
      });
    }
  }
  // 同步按钮
  private syncBranchButton() {
    if (this.checkSelected.length > 0) {
      this.clearData();

      this.checkboxSelected = [];
      this.isIndeterminate = false;
      this.branchVisible = true;
    } else {
      this.$notify({
        title: '提示',
        message: '请选择事件名称',
        type: 'warning'
      });
    }
  }
  // 分公司选中事件
  private handleBranchSelectionAll(val: any) {
    let options = [];
    for (let i = 0; i < this.branchList.length; i++) {
      options.push(this.branchList[i].id);
      if (this.branchList[i].child) {
        for (let m = 0; m < this.branchList[i].child.length; m++) {
          options.push(this.branchList[i].child[m].id);
          if (this.branchList[i].child[m].child) {
            for (let n = 0; n < this.branchList[i].child[m].child.length; n++) {
              options.push(this.branchList[i].child[m].child[n].id);
            }
          }
        }
      }
    }
    // $.unique(val.sort());
    this.checkboxSelected = val ? options : [];
    this.isIndeterminate = false;
  }
  // 事件选择事件
  private handleSelection(val: any) {
    // $.unique(val.sort());
    let checkedCount = val.length;
    let _length = this.branchList.length;

    for (let x = 0; x < this.branchList.length; x++) {
      for (let m = 0; m < val.length; m++) {
        if (this.branchList[x].child && this.branchList[x].id === val[m]) {
          // 把里面的子集id 放到数组里
          for (let n = 0; n < this.branchList[x].child.length; n++) {
            val.push(this.branchList[x].child[n].id);

            if (this.branchList[x].child[n].child) {
              for (
                let l = 0;
                l < this.branchList[x].child[n].child.length;
                l++
              ) {
                val.push(this.branchList[x].child[n].child[l].id);
              }
            }
          }
        }
      }
    }

    // $.unique(val.sort());
    this.checkboxSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }

  private handleSelectionTwo(val: any) {
    // $.unique(val.sort());

    let checkedCount = val.length;
    let _length = this.branchList.length;

    for (let x = 0; x < this.branchList.length; x++) {
      if (this.branchList[x].child) {
        // 把里面的子集id 放到数组里
        for (let n = 0; n < this.branchList[x].child.length; n++) {
          for (let m = 0; m < val.length; m++) {
            if (
              this.branchList[x].child[n].child &&
              this.branchList[x].child[n].id === val[m]
            ) {
              for (
                let l = 0;
                l < this.branchList[x].child[n].child.length;
                l++
              ) {
                val.push(this.branchList[x].child[n].child[l].id);
              }
            }
          }
        }
      }
    }
    // $.unique(val.sort());
    this.checkboxSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }

  private handleSelectionThree(val: any) {
    // $.unique(val.sort());
    let checkedCount = val.length;
    let _length = this.branchList.length;

    this.checkboxSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
}
